module.exports = __webpack_public_path__ + "static/img/banner-wrightin.bd5444f9.png";